import React from 'react';
import css from './SectionSchoolHero.module.css';
import Slider from 'react-slick';
import '../../../../styles/slick/slick.css';
import '../../../../styles/slick/slick-theme.css';
import campaignImg1 from '../../../../assets/sport-img1.png';
import classNames from 'classnames';

const brandSliderSettings = {
  dots: true,
  arrows: false,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 2200,
  speed: 500,
  cssEase: 'ease',
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const CampaignShowCase = ({ isMobileLayout }) => {
  return (
    <div className={classNames(css.campaignShowcaseSection, css.howItWorks)}>
      <div className={css.sectionHead}>
        <div className={css.leftSec}>
          <h2>Campaign Showcase</h2>
        </div>
      </div>
      <div className={css.sectionContent}>
        <div className={css.featuredListingsContent}>
          <div className={css.templatesSlider}>
            <Slider {...{ ...brandSliderSettings, arrows: !isMobileLayout }}>
              <div className={css.block}>
                <div className={css.blockImg} role="button">
                  <img src={campaignImg1} alt="name" />
                </div>
                <div className={css.blockInfo}>
                  <h3>Bill Catch</h3>
                  <p>
                    Bill Catch is a standout wide receiver for Rutgers University. The New Jersey
                    native combines exceptional speed with reliable hands, earning him the nickname
                    "Sticky Fingers" throughout the Big Ten Conference. At 6'2", he uses his height
                    advantage and precise route-running to consistently make difficult catches in
                    traffic.
                  </p>
                  <div className={css.timeSec}>
                    <span>5 days to go</span>
                    <span>77% funded</span>
                  </div>
                </div>
              </div>
              <div className={css.block}>
                <div className={css.blockImg} role="button">
                  <img src={campaignImg1} alt="name" />
                </div>
                <div className={css.blockInfo}>
                  <h3>Bill Catch</h3>
                  <p>
                    Bill Catch is a standout wide receiver for Rutgers University. The New Jersey
                    native combines exceptional speed with reliable hands, earning him the nickname
                    "Sticky Fingers" throughout the Big Ten Conference. At 6'2", he uses his height
                    advantage and precise route-running to consistently make difficult catches in
                    traffic.
                  </p>
                  <div className={css.timeSec}>
                    <span>5 days to go</span>
                    <span>77% funded</span>
                  </div>
                </div>
              </div>
              <div className={css.block}>
                <div className={css.blockImg} role="button">
                  <img src={campaignImg1} alt="name" />
                </div>
                <div className={css.blockInfo}>
                  <h3>Bill Catch</h3>
                  <p>
                    Bill Catch is a standout wide receiver for Rutgers University. The New Jersey
                    native combines exceptional speed with reliable hands, earning him the nickname
                    "Sticky Fingers" throughout the Big Ten Conference. At 6'2", he uses his height
                    advantage and precise route-running to consistently make difficult catches in
                    traffic.
                  </p>
                  <div className={css.timeSec}>
                    <span>5 days to go</span>
                    <span>77% funded</span>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignShowCase;
